import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-polyglot';
import classNames from 'classnames';
import Modal from '../Modal';
import { PrimaryButton } from '../buttons';
import FormFeedback from '../form/FormFeedback';
import './DiaryForgotPinModal.css';

function DiaryForgotPinModal(props) {
  const {
    isFailureMessageVisible,
    isLoading,
    isOpen,
    isSuccessMessageVisible,
    onRequestClose,
    onSubmit,
    t
  } = props;

  function handleClose() {
    if (!isLoading) {
      onRequestClose();
    }
  }

  return (
    <Modal
      className={classNames('diary-forgot-pin-modal', {
        'diary-forgot-pin-modal--success': isSuccessMessageVisible
      })}
      isOpen={isOpen}
      onRequestClose={handleClose}
      showCloseButton={!isLoading}
    >
      {isSuccessMessageVisible ? (
        <Fragment>
          <h2>{t('diaryForgot.sentTitle')}</h2>
          <p>{t('diaryForgot.sentDescription')}</p>
          <p>{t('diaryForgot.sentDelay')}</p>
        </Fragment>
      ) : (
        <Fragment>
          <h2>{t('diaryForgot.title')}</h2>
          <p>{t('diaryForgot.description')}</p>
          {isFailureMessageVisible && (
            <FormFeedback positive={false}>
              {t('diaryForgot.failureDescription')}
            </FormFeedback>
          )}
          <PrimaryButton
            onClick={onSubmit}
            disabled={isLoading}
            loading={isLoading}
          >
            {t('diaryForgot.button')}
          </PrimaryButton>
        </Fragment>
      )}
    </Modal>
  );
}

DiaryForgotPinModal.propTypes = {
  isFailureMessageVisible: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isOpen: PropTypes.bool.isRequired,
  isSuccessMessageVisible: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired
};

export default translate()(DiaryForgotPinModal);



// WEBPACK FOOTER //
// ./src/components/diary/DiaryForgotPinModal.js